/**
 *
 * @param {number} num
 * @param {number} precision
 * @returns string
 */
export function round(num, precision) {
  const base = 10 ** precision
  return (Math.round(num * base) / base).toFixed(precision)
}

/**
 *
 * @param {number} num
 * @returns string
 */
export function numberWithCommas(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 *
 * @param {number} price_in_cents
 * @param {number} dec
 * @returns string
 */
export function dollarPrice(price_in_cents, dec = 2) {
  if (typeof price_in_cents === 'string') {
    price_in_cents = parseInt(price_in_cents, 10)
  }
  if (typeof price_in_cents !== 'number' || typeof dec !== 'number') return false
  const num_sign = price_in_cents >= 0 ? 1 : -1

  const result = (
    Math.round((price_in_cents / 100) * Math.pow(10, dec) + num_sign * 0.0001) / Math.pow(10, dec)
  ).toFixed(dec)

  return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
